module.exports = __webpack_public_path__ + "img/jp.16a568ca.svg";